module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-big-d54ac75bc8cebe8a8b8a324653070e87.png";